import { render } from "./ListModules.vue?vue&type=template&id=fb82a5c2"
import script from "./ListModules.vue?vue&type=script&lang=js"
export * from "./ListModules.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__